<template>
  <div>
    <div class="text-center mb-2">
      <el-radio-group v-model="field.is_global_variable">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>
    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <!-- <el-row :gutter="50">
        <el-col :span="12">
          <div class="form-group">
            <el-form-item label="Validations">
              <el-date-picker
                type="date"
                placeholder="Min date"
                v-model="field.validations.min"
                style="width: 100%;"
                format="yyyy-dd-MM"
              ></el-date-picker>
              <el-date-picker
                type="date"
                placeholder="Max date"
                v-model="field.validations.max"
                style="width: 100%;"
                format="yyyy-dd-MM"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-col>
      </el-row>-->
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <field-attributes :field="field" />
        </el-col>
        <el-col :span="12">
          <is-field-required :field="field" class="field-required" />
        </el-col>
        <el-col :span="10">
          <div class="icon-dropdown-selection">
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <div class="form-group">
            <el-form-item label="Global Variable">
              <el-select
                v-model="field.global_variable_id"
                @change="setGlobalVariable"
              >
                <el-option
                  v-for="(globalVariable, index) of allGlobalVariables"
                  :key="index"
                  :label="globalVariable.label"
                  filterable
                  :value="globalVariable._id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <is-field-required :field="field" class="field-required" />
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
    <el-row :gutter="20" type="flex" align="middle">
      <el-col :span="8">
        <el-checkbox v-model="field.properties.configure_date_and_time"
          >Configure With Date & Time</el-checkbox
        >
      </el-col>

      <el-col :span="10" v-if="field.properties.configure_date_and_time">
        <el-select
          v-model="field.selectedDateField"
          placeholder="Select Date Field"
          style="width: 100%"
        >
          <el-option
            v-for="template in filteredDateFields"
            :key="template._id"
            :label="template.label"
            :value="template.key"
          />
        </el-select>
      </el-col>
      <el-col :span="10" v-if="field.properties.configure_date_and_time">
        <el-select
          v-model="field.selectedTimeField"
          placeholder="Select Time Field"
          style="width: 100%"
        >
          <el-option
            v-for="template in filteredTimeFields"
            :key="template._id"
            :label="template.label"
            :value="template.key"
          />
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";
import { fetchGlobalVariables } from "@/repo/globalVariables";
// import TitleAndDescription from "./TitleAndDescription";
// import IsFieldRequired from "./IsFieldRequired";
// import FieldFilledBy from "./FieldFilledBy";
// import Placeholder from "./Placeholder";
// import FieldAttributes from "./FieldAttributes";
export default {
  name: "templates-formComponents-Date",
  components: {
    TitleAndDescription: () => import("./TitleAndDescription"),
    IsFieldRequired: () => import("./IsFieldRequired"),
    FieldFilledBy: () => import("./FieldFilledBy"),
    Placeholder: () => import("./Placeholder"),
    FieldAttributes: () => import("./FieldAttributes"),
  },
  props: ["field", "selfTemplate",],
  computed: {
    // ...mapGetters("globalVariables", ["getAllGlobalVariables"]),
    allGlobalVariables() {
      return this.getAllGlobalVariables
        ? this.getAllGlobalVariables.data || []
        : [];
    },
     filteredDateFields() {
      let inputTypes = ["DATE","DATE_TIME"];
      return this.selfTemplate.filter(
        (field) =>
         this.field.key !== field.key && inputTypes.includes(field.inputType)
      );
    },
    filteredTimeFields() {
      let inputTypes = ["TIME","SLOT"];
      return this.selfTemplate.filter(
        (field) =>
         this.field.key !== field.key && inputTypes.includes(field.inputType)
      );
    },
  },
  data() {
    return {
      iconPickerdialogVisible: false,
      getAllGlobalVariables: null,
      validations: [],
      templateIconPath: "",
    };
  },
  mounted() {
    this.fetchGlobalVaribales();
    if (this.field && this.field.icon_name) {
      this.templateIconPath = this.field.icon_name;
    }
  },
  methods: {
    closeSelectIcon() {
      this.iconPickerdialogVisible = false;
    },
    getIconPath(icon) {
      this.templateIconPath = icon;
      this.$set(this.field, "icon_name", icon);
      this.iconPickerdialogVisible = false;
    },
    async fetchGlobalVaribales() {
      let params = {
        get_all: true,
        input_type: this.field.input_type,
      };
      this.getAllGlobalVariables = await fetchGlobalVariables(params);
    },
    setGlobalVariable() {
      let globalVariable = this.allGlobalVariables.find(
        (x) => x._id == this.field.global_variable_id
      );
      this.field.label = globalVariable.label;
      this.field.description = globalVariable.description;
    },
  },
};
</script>

<style lang="scss"></style>
